import React from 'react';
import AppRoutes from './routes';

const App = () => <AppRoutes />;

export default App;